var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "page-header" }, [
    _vm.breadcrumb.length
      ? _c(
          "nav",
          { staticClass: "breadcrumb", attrs: { "aria-label": "breadcrumbs" } },
          [
            _c(
              "ul",
              [
                _vm._l(_vm.breadcrumbRoutes, function (item, index) {
                  return [
                    _c(
                      "li",
                      {
                        key: index,
                        class: {
                          "is-active": index === _vm.breadcrumb.length - 1,
                        },
                      },
                      [
                        _c("router-link", { attrs: { to: item.path } }, [
                          _vm._v(" " + _vm._s(item.meta.title) + " "),
                        ]),
                      ],
                      1
                    ),
                  ]
                }),
              ],
              2
            ),
          ]
        )
      : _vm._e(),
    _c("h1", { staticClass: "title" }, [_vm._v(" " + _vm._s(_vm.title) + " ")]),
    _c("h2", { staticClass: "subtitle" }, [
      _vm._v(" " + _vm._s(_vm.subtitle) + " "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }